import app from 'flarum/forum/app';
import AlbumListPage from './pages/AlbumListPage';
import AlbumShowPage from './pages/AlbumShowPage';
import PictureShowPage from './pages/PictureShowPage';
import PictureListPage from './pages/PictureListPage';
import UserPicturePage from './pages/UserPicturePage';

export default function () {
    app.routes.cimaiseAlbumList = {
        path: '/albums',
        component: AlbumListPage,
    };

    app.routes.cimaiseAlbumShow = {
        path: '/albums/:id',
        component: AlbumShowPage,
    };

    app.routes.cimaisePictureShow = {
        path: '/albums/:album/:id',
        component: PictureShowPage,
    };

    app.routes.cimaisePictureList = {
        path: '/pictures',
        component: PictureListPage,
    };

    app.routes.cimaiseUserPictures = {
        path: '/u/:username/pictures',
        component: UserPicturePage,
    };
}
